import React, { useEffect } from 'react';
import { Email } from '@mui/icons-material';
import { Box, Grid, Paper, Typography } from '@mui/material'
import logo from "../../../assets/images/logo.jpeg"
import register from "../../../assets/images/register.png";
import { useNavigate } from 'react-router-dom';
const ConfirmationPage = () => {
  const navigate = useNavigate()

  // Optional: Automatically redirect after a certain time
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/talents")
    }, 7000)

    return () => clearTimeout(timer)
  }, [navigate])


  return (
    <Grid container component = "main" sx = {{ height: "100vh" }
}>
      {/* Left Image Section */}
      <Grid
        item
        xs={false}
        sm={false}
        md={6}
        sx={{
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      >
        <img
          src={register}
          alt="Student with laptop"
          fill
          style={{ objectFit: "cover" }}
          priority
        />
      </Grid>

      {/* Right Content Section */}
      <Grid item xs={12} md={6} component={Paper} elevation={0} square>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "auto",
            px: 4,
            maxWidth: 500,
            mx: "auto",
            py: 4,
          }}
        >
          <Box sx={{ mb: 6, width: "100%", maxWidth: 120 }}>
            <img
              src={logo}
              alt="E1X Academy Logo"
              width={120}
              height={60}
              style={{ objectFit: "contain" }}
            />
          </Box>
          <Typography component="h1" variant="h4" fontWeight="bold" sx={{ mb: 8, mt: 10 }}>
            Thanks for applying to our Talent Matching program
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}> <Email style={{ color: '#E84A1C', mr:2}} />
            Please Check Your Inbox
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            We’ve received your information and will be sending an email to you with further instructions. Keep an eye on your inbox for the next steps.
          </Typography>

        </Box>
        
      </Grid>

    </Grid>
  );
};

export default ConfirmationPage;
